import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIdle, useToggle } from 'react-use';
import ConfirmActivityModal from './ConfirmActivityModal';

const ACTIVITY_TIMEOUT = 2 * 60 * 1000; // 2 minutes

const ConfirmActivity = (props) => {
  const isIdle = useIdle(ACTIVITY_TIMEOUT);
  const [showConfirmActivityModal, toggleActivityModal] = useToggle(false);

  useEffect(() => {
    if ( isIdle && !showConfirmActivityModal ) toggleActivityModal(true);
  }, [isIdle, showConfirmActivityModal]);

  if ( !showConfirmActivityModal ) return null;
  return (
    <ConfirmActivityModal
      onConfirm={() => toggleActivityModal(false)}
      onTimeout={() => {
        toggleActivityModal(false);
        props.startOver();
      }}
      timeoutDurationInSeconds={props.timeoutDurationInSeconds}
      descriptionText={props.descriptionText}
    />
  );
}

ConfirmActivity.propTypes = {
  startOver: PropTypes.func.isRequired,
  descriptionText: PropTypes.string.isRequired,
  timeoutDurationInSeconds: PropTypes.number.isRequired
};

export default ConfirmActivity;
